import React from 'react';
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {Button, Result} from 'antd';
import {useTranslation} from 'react-i18next';
import {ResourceCode} from 'constants/resourceCodes';
import {isLoggedIn, logout} from 'utils/auth';
import {hasResource} from 'utils/resourceAuth';
import MobileLoginPage from './MobileLoginPage';
import MobileWorkPage from './MobileWorkPage';
import {MOBILE_LOGIN_PATH, mobileLoginUrl} from './mobilePaths';

/**
 * 手机版守卫：未登录 → 手机登录页（带回跳地址，Lark 卡片链接登录后能回到那条任务）；
 * 已登录但没有作业端资源码 → 无权限页，可退出换号。
 */
const MobileGuard: React.FC<{children: React.ReactElement}> = ({children}) => {
  const {t} = useTranslation();
  const location = useLocation();
  if (!isLoggedIn()) {
    return <Navigate to={mobileLoginUrl(location.pathname + location.search)} replace/>;
  }
  if (!hasResource([ResourceCode.cs.CS_COMPLAINT_TASK_WORK])) {
    return (
      <Result
        status="403"
        title={t('complaintMobile.noPermission')}
        extra={<Button type="primary" onClick={() => logout(MOBILE_LOGIN_PATH)}>{t('login.logout')}</Button>}
      />
    );
  }
  return children;
};

/** 客诉手机版（/complaint-platform/*）：独立全屏页面，不挂 PC 主菜单（PRD：手机版不放管理端入口）。 */
const ComplaintPlatformRoutes: React.FC = () => (
  <Routes>
    <Route path="work-mobile/login" element={<MobileLoginPage/>}/>
    <Route path="work-mobile" element={<MobileGuard><MobileWorkPage/></MobileGuard>}/>
  </Routes>
);

export default ComplaintPlatformRoutes;
